export const SECOND = 1000;
export const HALF_SECOND = SECOND / 2;
